import { ObjectValues } from 'types';

export const AuthEventTypes = {
  REFRESH_TOKEN_SUCCESS: 'REFRESH_TOKEN_SUCCESS',
  REFRESH_TOKEN_FAIL: 'REFRESH_TOKEN_FAIL',
  LOGOUT_SIGNAL: 'LOGOUT_SIGNAL',
  FORBIDDEN_SIGNAL: 'FORBIDDEN_SIGNAL',
} as const;

export type AuthEvents = ObjectValues<typeof AuthEventTypes>;

export type EventName = AuthEvents;

export type CallbackBusType<T> = {
  event: EventName;
  payload: T;
};

export default {
  listeners: {} as Record<EventName, Array<any>>,
  addEventListener<T = any>(
    event: EventName,
    callback: (data: CallbackBusType<T>) => void,
  ) {
    if (!this.listeners[event]) this.listeners[event] = [];
    this.listeners[event].push(callback);

    return () => {
      this.removeEventListener(event, callback);
    };
  },
  removeEventListener<T = any>(
    event: EventName,
    callback: (data: CallbackBusType<T>) => void,
  ) {
    this.listeners[event] = this.listeners[event].filter(
      (cb) => cb !== callback,
    );
  },
  broadcastEvent<T = any>(event: EventName, payload?: T) {
    if (this.listeners[event])
      this.listeners[event].forEach((cb) => cb({ payload, event }));
  },
  addMultiEventListener<T = any>(
    events: EventName[],
    callback: (data: CallbackBusType<T>) => void,
  ) {
    events.forEach((event) => {
      if (!this.listeners[event]) this.listeners[event] = [];
      this.listeners[event].push(callback);
    });
  },
  removeMultiEventListener<T = any>(
    events: EventName[],
    callback: (data: CallbackBusType<T>) => void,
  ) {
    events.forEach((event) => {
      this.listeners[event] = this.listeners[event].filter(
        (cb) => cb !== callback,
      );
    });
  },
};
